import * as React from 'react'

import ModuleCard from './ModuleCard'
import IconType from '../../general/Icon/iconTypes'
import { colours } from '../../config/theme'

export const DocumentsModuleCard = () => (
  <ModuleCard
    backgroundColor={colours.status.popout}
    icon={IconType.DocsHexagon}
    link="/organisation/documents"
    linkText="Find out more"
    subtitle="Store all your important documents in one central location."
    title="Policies"
  />
)
